<script setup lang="ts">
import type { TabNavigation } from "~/core/components/TabsWithNavigation.vue";
import { PATH_DTWINS } from "~/modules/dtwin/constants";
import { DtwinListDisplayContext } from "~/modules/dtwin/models/DtwinListDisplayContext.enum";

const pageComponentRef = ref();

const dtwinFormRef = ref();

const dtwin = computed(() =>
  dtwinFormRef.value ? dtwinFormRef.value.dtwin : undefined,
);

const dtwinModel = computed(() =>
  dtwinFormRef.value ? dtwinFormRef.value.dtwinModel : undefined,
);

const backExcludeRoutes = computed(() =>
  dtwinFormRef.value
    ? dtwinFormRef.value?.tabNavigations.map(
        (tabNavigation: TabNavigation) => tabNavigation.redirectPath,
      )
    : [],
);

const breadcrumbContainerRef = computed(() =>
  pageComponentRef.value
    ? pageComponentRef.value.breadcrumbContainerRef
    : undefined,
);

const containerComponentRef = computed(() =>
  pageComponentRef.value
    ? pageComponentRef.value.containerComponentRef
    : undefined,
);

function fetchData() {
  if (dtwinFormRef.value) {
    dtwinFormRef.value.fetchData();
  }
}
</script>

<template>
  <page-component
    ref="pageComponentRef"
    :name="dtwin?.attributes.friendlyName"
    should-not-translate
    :back-default-route="PATH_DTWINS"
    :back-exclude-routes="backExcludeRoutes"
    check-license
  >
    <template #top-right>
      <dtwin-actions
        v-if="dtwin"
        :dtwin="dtwin"
        :dtwin-model="dtwinModel"
        :context="DtwinListDisplayContext.DTWIN_DETAIL"
        @life-cycle-state-updated="fetchData"
      />
    </template>
    <div ref="breadcrumbContainerRef" class="flex justify-between"></div>
    <dtwin-form
      ref="dtwinFormRef"
      :breadcrumb-container="breadcrumbContainerRef"
      :container="containerComponentRef"
    />
  </page-component>
</template>
